import { render, staticRenderFns } from "./area52.vue?vue&type=template&id=24997209"
import script from "./area52.vue?vue&type=script&lang=js"
export * from "./area52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../sa-platform-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports